import { render } from "./ConsignedCreate.vue?vue&type=template&id=1a5e824a"
import script from "./ConsignedCreate.vue?vue&type=script&lang=js"
export * from "./ConsignedCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__